import UPSearchInput from './UPSearchInput';

export default UPSearchInput;
